import { axios, multipartAxios } from "./setup.interseptor";

// Login request
export const userLoginRequest = (body) => {
  return axios({
    method: "POST",
    url: "/login",
    data: body,
  });
};

// Logout request
export const userLogoutRequest = (body) => {
  return axios({
    method: "POST",
    url: "/user/logout",
    data: body,
  });
};

export const MultiUpdateRequest = (body) => {
  return axios({
    method: "POST",
    url: "/campaign/c-t",
    data: body,
  });
};

export const SetBlastIVR = (body) => {
  return axios({
    method: "POST",
    url: `/campaign/set-blast`,
    data: body,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// Get countries
export const getAllCountriesRequest = () => {
  return axios({
    method: "GET",
    url: "/fetchAllCountries",
  });
};

// Get users with pagination and search
export const getUserRequest = (page, perpage, searchTerm) => {
  return axios({
    method: "GET",
    url: `/user/list?page=${page}&perpage=${perpage}&params=${searchTerm}`,
  });
};
export const getTrunkRequest = (page, perpage, searchTerm) => {
  return axios({
    method: "GET",
    url: `/trunk/list?page=${page}&Perpage=${perpage}&search=${searchTerm}`,
  });
}; // 👈 Don't add extra lines or spaces after this
export const getAllCdrRequest = (page, perpage, searchTerm) => {
  return axios({
    method: "GET",
    url: `/report?page=${page}&perpage=${perpage}`,
    params: searchTerm,
  });
};

export const getOutboundCdrRequest = () => {
  return axios({
    method: "GET",
    url: `/trunk/outbound`,
  });
};

export const addTrunkRequest = (body) => {
  return axios({
    method: "POST",
    url: `/trunk/add`,
    data: body,
  });
};

export const deleteTrunkRequest = (id) => {
  return axios({
    method: "DELETE",
    url: `/trunk/${id}`,
  });
};

export const updateTrunkRequest = (body) => {
  return axios({
    method: "PUT",
    url: `/trunk/${body.id}`,
    data: body,
  });
};

export const changeTrunkStatusRequest = (id, body) => {
  return axios({
    method: "PATCH",
    url: `/trunk/status/${id}`,
    data: body,
  });
};

// campaign
export const getCampaignRequest = (page, perpage, searchTerm) => {
  return axios({
    method: "GET",
    url: `/campaign/campaigns?page=${page}&Perpage=${perpage}&search=${searchTerm}`,
  });
};

export const addCampaignRequest = (body) => {
  return axios({
    method: "POST",
    url: `/campaign/add`,
    data: body,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
// export const addCampaignRequest = (body) => {
//   return axios({
//     method: "POST",
//     url: `/campaign/add-campaign`,
//     data: body,
//     headers: {
//       "Content-Type": "multipart/form-data",
//     },
//   });
// };

export const deleteCampaignRequest = (id) => {
  return axios({
    method: "DELETE",
    url: `/campaign/${id}`,
  });
};

export const updateCampaignRequest = (formData, id) => {
  // formData.append("_method", "PUT");

  return axios({
    method: "POST",
    url: `/campaign/${id}`,
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const changeCampaignStatusRequest = (id, body) => {
  return axios({
    method: "PATCH",
    url: `/campaign/status/${id}`,
    data: body,
  });
};
export const ChangeAdminPasswordRequest = (body) => {
  return axios({
    method: "POST",
    url: `/user/password`,
    data: body,
  });
};

export const getCallerIDRequest = (page, perpage) => {
  return axios({
    method: "GET",
    url: `/campaign/cid?page=${page}&per_page=${perpage}`,
  });
};

export const AddCallerIDRequest = (body) => {
  return axios({
    method: "POST",
    url: `/campaign/add/cid`,
    data: body,
  });
};

export const getCdrRequest = (page, perpage, filters = {}) => {
  const params = new URLSearchParams({
    page,
    per_page: perpage,
    ...filters,
  });

  return axios({
    method: "GET",
    url: `/report/cdr?${params.toString()}`,
  });
};

export const getPhoneNumberRequest = () => {
  return axios({
    method: "GET",
    url: `/user/phone-numbers`,
  });
};

export const getCampaignNameRequest = () => {
  return axios({
    method: "GET",
    url: `/campaign/all`,
  });
};

export const getDashboardCountsRequest = () => {
  return axios({
    method: "GET",
    url: `/dashboard/dialer`,
  });
};

// export const getDashboardGraphsRequest = () => {
//   return axios({
//     method: "GET",
//     url: `/dashboard/call-counts`,
//   });
// };

export const getAudioListRequest = () => {
  return axios({
    method: "GET",
    url: `/tts/audios`,
  });
};

export const addAudioRequest = (body) => {
  return axios({
    method: "POST",
    url: `/tts/generate-audio`,
    data: body,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
